import { useState } from "react";
import ActiveIcon from "../../../assets/icons/ActiveIcon";
import BlockedIcon from "../../../assets/icons/BlockedIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import TelegramIcon from "../../../assets/icons/TelegramIcon";
import CustomTable from "../CustomTable/CustomTable";
import styles from "../CustomTable/CustomTable.module.scss";
import { useTranslation } from "react-i18next";

const TeamTable = () => {
  const { t } = useTranslation();
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    {
      title: t("teamTable.avatar"),
      dataIndex: "avatar",
      key: "avatar",
      render: (text) => (
        <p>
          <TelegramIcon />
        </p>
      ),
    },
    {
      title: t("teamTable.email"),
      dataIndex: "mail",
      key: "mail",
      align: "center",
    },
    {
      title: t("teamTable.name"),
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: t("teamTable.role"),
      dataIndex: "role",
      key: "role",
      align: "center",
    },
    { title: t("teamTable.created"), dataIndex: "created", key: "created" },
    {
      title: t("teamTable.confirmed"),
      dataIndex: "confirmed",
      key: "confirmed",
      align: "center",
      render: (item) => <div>{item ? <ActiveIcon /> : <BlockedIcon />}</div>,
    },
    {
      title: t("teamTable.actions"),
      key: "actions",
      render: () => (
        <div className={styles.tableActions}>
          <button className={styles.delete}>
            <DeleteIcon />
          </button>
          <button className={styles.edit}>
            <EditIcon />
          </button>
        </div>
      ),
      align: "center",
    },
  ];

  const mockData = Array.from({ length: 15 }, (_, i) => ({
    key: i,
    avatar: `Avatar ${i + 1}`,
    mail: `user${i + 1}@example.com`,
    name: `User ${i + 1}`,
    role: `Role ${i + 1}`,
    created: `2025-03-20`,
    confirmed: i % 2 === 0,
  }));

  return <CustomTable columns={columns} mockData={mockData} />;
};

export default TeamTable;
